import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * Marker colour carries the state, so the map needs a key. Without it the
 * palette is private knowledge.
 *
 * Un élément porte soit une teinte pleine (`color`, une famille d'état), soit
 * un liseré (`ring`, le signal : la carte dessine le liseré vert ou rouge
 * autour du disque), soit une teinte pâle (`dashed`, un tracé en pointillés).
 * `repliable` : sur téléphone la légende se replie derrière un bouton (huit
 * entrées sur 320 px mangeaient la moitié de la carte). Hors option, elle reste
 * affichée comme avant.
 */
export default function MapLegend({ items, repliable = false }) {
  const [ouverte, setOuverte] = useState(false);
  if (!items || items.length === 0) return null;

  return (
    <div className="pointer-events-none absolute bottom-3 left-3 z-[400] max-w-[calc(100%-1.5rem)]">
      <div className="flex flex-col items-start gap-1">
        {repliable && (
        <button
          type="button"
          onClick={() => setOuverte((v) => !v)}
          aria-expanded={ouverte}
          className="pointer-events-auto inline-flex items-center gap-1 rounded-lg border border-border bg-card/90 px-2.5 py-1 text-[11px] font-semibold text-muted-foreground shadow-sm backdrop-blur-sm sm:hidden"
        >
          Légende
          {ouverte ? (
            <ChevronDown className="h-3 w-3" aria-hidden="true" />
          ) : (
            <ChevronUp className="h-3 w-3" aria-hidden="true" />
          )}
        </button>
        )}
        <ul
          aria-label="Légende de la carte"
          className={`${
            !repliable || ouverte ? 'flex' : 'hidden'
          } flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-border bg-card/90 px-2.5 py-1.5 shadow-sm backdrop-blur-sm sm:flex`}
        >
          {items.map((item) => (
            <li key={item.key} className="flex items-center gap-1.5">
              {item.ring ? (
                <span
                  className="h-2.5 w-2.5 rounded-full bg-muted"
                  style={{ border: `2.5px solid ${item.ring}` }}
                  aria-hidden="true"
                />
              ) : (
                <span
                  className="h-2.5 w-2.5 rounded-full"
                  style={{
                    backgroundColor: item.color,
                    // Dashed entries on the map are drawn dashed in the key too, so
                    // the distinction survives a colour-blind reading.
                    opacity: item.dashed ? 0.55 : 1,
                  }}
                  aria-hidden="true"
                />
              )}
              <span className="text-[11px] font-medium text-muted-foreground">{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
